export const isEmailAlreadyExistError = (error: Error) => {
  try {
    return JSON.parse(error.message)?.info?.code === 'account_already_exists';
  } catch (e) {
    return false;
  }
};
